<div class="settings-tools">
  <ul class="nav nav-tabs line-tab fixnav">
    <li class="nav-item" role="presentation" *ngFor="let option of tabList">
      <a
        [routerLink]="'../' + configurationSettingsData[option].type"
        role="tab"
        data-toggle="tab"
        [className]="'nav-link ' + (isCurrentPath(configurationSettingsData[option].type) ? 'active' : '')"
        [attr.aria-selected]="isCurrentPath(configurationSettingsData[option].type)"
        *ngIf="true || userPermissions[configurationSettingsData[option].permission]?.view">
        {{ configurationSettingsData[option].label }}
      </a>
    </li>
  </ul>
  <ng-container *ngIf="true || userPermissions[configurationSettingsData[currentPath].permission]?.view">
    <div class="tab-content mainTabContent">
      <app-configuration-settings-bar
        [configurationSettingsData]="configurationSettingsData[currentPath]"
        [editAccess]="userPermissions.tools_setting.edit"
        (search)="performSearch($event)"
        (create)="performCreate($event)"></app-configuration-settings-bar>

      <div class="tab-pane fade show active" role="tabpanel">
        <app-configuration-settings-table
          [headers]="configurationSettingsData[currentPath]"
          [rows]="configurationSettingsData[currentPath].data"
          [sortData]="searchParams.order"
          (action)="handleAction($event)">
        </app-configuration-settings-table>
        <app-configuration-settings-paging
          [links]="configurationPagingData[currentPath]"
          (navigation)="performPaging($event)">
        </app-configuration-settings-paging>
      </div>
    </div>
  </ng-container>
</div>

<!-- configuration dialog prompt -->
<app-dialog id="configuration-dialog">
  <div class="dialog-header d-flex justify-content-between">
    <h5 class="modal-title" id="exampleModalLabel">{{ dialogRecord.actionName }} {{ dialogRecord.settingType }}</h5>
  </div>
  <span class="dialog-body">
    <span *ngIf="dialogRecord.actionType === 'status' || dialogRecord.actionType === 'delete'"
      >Are you sure you want to {{ dialogRecord.actionName | lowercase }} <b>{{ dialogRecord.data.name }}</b
      >?</span
    >
    <span *ngIf="dialogRecord.actionType === 'create' || dialogRecord.actionType === 'edit'">
      <span *ngIf="dialogRecord.settingType == 'Employee Types'; else statusFields">
        <div class="col-12">
          <div class="form-group">
            <label>Icon Color</label>
            <input type="color" class="form-control" [(ngModel)]="newRecord.color" />
          </div>
        </div>
        <div class="col-12">
          <div class="form-group">
            <label>Rank</label>
            <input type="number" class="form-control" [(ngModel)]="newRecord.rank" />
          </div>
        </div>
        <div class="col-12">
          <div class="form-group">
            <label>Status</label><br />
            <app-toggle [(enabled)]="newRecord.status" (toggle)="handleToggle($event)" [allowChanges]="true">
            </app-toggle>
          </div>
        </div>
      </span>
      <ng-template #statusFields>
        <div class="col-12">
          <div class="form-group">
            <label>Name</label>
            <input type="text" class="form-control" [(ngModel)]="newRecord.name" />
          </div>
        </div>
        <div class="col-12">
          <div class="form-group">
            <label>Description</label>
            <textarea class="form-control" rows="4" [(ngModel)]="newRecord.description"></textarea>
          </div>
        </div>
        <div class="col-12">
          <div class="form-group">
            <label>Status</label><br />
            <app-toggle [(enabled)]="newRecord.status" (toggle)="handleToggle($event)" [allowChanges]="true">
            </app-toggle>
          </div>
        </div>
      </ng-template>
    </span>
  </span>
  <span class="dialog-footer">
    <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
    <button
      [disabled]="newRecord.name == '' && dialogRecord.actionType != 'delete'"
      type="button"
      class="btn btn-primary ml-3"
      id="configuration-dialog_btn-ok">
      Continue
    </button>
  </span>
</app-dialog>
